<template>
    <div>
        <div class="logo" :class="{ collapsed: isChatListCollapsed }">
            <LogoComponent :isCollapsed="isChatListCollapsed" />
        </div>
        <div v-show="this.showTopBar" class="topbar">
            <button class="nav-button" @click="navigateToProductIntro">产品介绍</button>
            <!-- <button>其他服务</button> -->
            <button class="nav-button" @click="navigateToContactPage">联系我们</button>
        </div>
        <div v-show="!ifLogin" class="loginButton">
            <LoginButton @setShowLogin="showLoginPage" />
        </div>
        <div v-show="ifLogin" class="loginButton">
            <UserInfoButton />
        </div>
        <div v-show=this.showLogin class="loginPage">
            <LoginPage @setShowLogin="showLoginPage"/>
        </div>
    </div>
</template>

<script>
import LoginButton from '../components/LoginButton.vue'
import LogoComponent from '../components/LogoComponent.vue'
import UserInfoButton from './UserInfoButton.vue';
import LoginPage from '../pannels/LoginPage.vue'
export default {
    name: 'TopBar',
    components: {
        LoginButton,
        LogoComponent,
        UserInfoButton,
        LoginPage
    },
    data() {
        return {
            showLogin: false
        }
    },
    computed: {
        ifLogin() {
            return this.$store.state.loginStatus
        },
        showTopBar() {
            return this.$route.name == 'homepage' || this.$route.name == 'ProductIntro' || this.$route.name == 'ContactPage';
        },
        isChatListCollapsed() {
            // 只有在聊天页面时才应用折叠状态
            return this.$route.name === 'chat' && this.$store.state.isChatListCollapsed
        }

    },
    methods: {
        showLoginPage(ifshow) {
            this.showLogin = ifshow
        },
        navigateToProductIntro() {
            if (this.$route.name != 'ProductIntro')
            this.$router.push({ name: 'ProductIntro' });
        },
        navigateToContactPage() {
            if (this.$route.name != 'ContactPage')
            this.$router.push({ name: 'ContactPage' });
        }
    }
}
</script>
<style scoped>
.topbar {
    display: flex;
    justify-content: center;

}

button {
    padding: 15px 15px;
    margin-left: 30px;
    margin-right: 30px;
    background-color: #ffffff00;
    border: 0px;
    font-family: PingFang SC;
    font-size: 28px;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
    z-index: 10;
}

button:hover {
    background-color: #0056b3;
}

.loginButton {
    position: fixed;
    right: 18px;
    top: 17px;
    z-index: 10;
}

/* Logo折叠样式 */
.logo {
    transition: transform 0.3s ease;
}

.logo.collapsed {
    transform: translateX(-200px);
}

/* 手机端响应式样式 */
@media (max-width: 768px) {
    .nav-button {
        display: none;
    }
    
    .topbar {
        height: 50px;
    }
    
    .logo.collapsed {
        transform: translateX(-100px);
    }
}
</style>
